"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PencilSquare16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Pencil/Square/16" },
            react_1.default.createElement("path", { id: "Mask", fillRule: "evenodd", clipRule: "evenodd", d: "M7 2V0H2L1.85077 0.00547998C0.816096 0.08175 0 0.94469 0 1.99935V13.9915L0.00548715 14.1408C0.0818557 15.1759 0.945867 15.9909 2 15.9909H14L14.1492 15.9854C15.1839 15.9091 16 15.0462 16 13.9915V7.99478H14V13.9909L2 13.99V2H7ZM12.1448 0.440881L6 6.58168V9.99479H9.41402L15.5586 3.85425C16.0252 3.38793 16.0387 2.62294 15.563 2.14762L13.8507 0.436404C13.3789 -0.035059 12.6132 -0.027247 12.1448 0.440881ZM12.999 2.413L13.585 2.998L8.586 7.994H8V7.409L12.999 2.413Z", fill: "#383F49" })));
}
function PencilSquare16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PencilSquare16Svg, Object.assign({}, svgProps)));
}
exports.default = PencilSquare16;
//# sourceMappingURL=PencilSquare16.js.map